var map = {
	"./Fast Card Logo.png": 5457,
	"./bidding-operation.png": 1087,
	"./challenge-and-win.png": 4316,
	"./chip_computer.png": 8844,
	"./chip_player.png": 5248,
	"./clubs-10.png": 7955,
	"./clubs-2.png": 9264,
	"./clubs-3.png": 4089,
	"./clubs-4.png": 4262,
	"./clubs-5.png": 591,
	"./clubs-6.png": 5940,
	"./clubs-7.png": 5885,
	"./clubs-8.png": 6026,
	"./clubs-9.png": 3603,
	"./clubs-ace.png": 8263,
	"./clubs-jack.png": 1649,
	"./clubs-king.png": 7565,
	"./clubs-queen.png": 8436,
	"./diamonds-10.png": 3433,
	"./diamonds-2.png": 5286,
	"./diamonds-3.png": 4303,
	"./diamonds-4.png": 2080,
	"./diamonds-5.png": 8329,
	"./diamonds-6.png": 8594,
	"./diamonds-7.png": 9723,
	"./diamonds-8.png": 236,
	"./diamonds-9.png": 6773,
	"./diamonds-ace.png": 9781,
	"./diamonds-jack.png": 6179,
	"./diamonds-king.png": 4319,
	"./diamonds-queen.png": 6826,
	"./game-interface.png": 5280,
	"./hearts-10.png": 9725,
	"./hearts-2.png": 5602,
	"./hearts-3.png": 3083,
	"./hearts-4.png": 820,
	"./hearts-5.png": 8301,
	"./hearts-6.png": 7062,
	"./hearts-7.png": 6079,
	"./hearts-8.png": 8600,
	"./hearts-9.png": 6865,
	"./hearts-ace.png": 6713,
	"./hearts-jack.png": 503,
	"./hearts-king.png": 5395,
	"./hearts-queen.png": 8342,
	"./rules.png": 3903,
	"./spades-10.png": 5014,
	"./spades-2.png": 4871,
	"./spades-3.png": 7182,
	"./spades-4.png": 9649,
	"./spades-5.png": 3352,
	"./spades-6.png": 6563,
	"./spades-7.png": 4986,
	"./spades-8.png": 8845,
	"./spades-9.png": 6340,
	"./spades-ace.png": 3396,
	"./spades-jack.png": 4028,
	"./spades-king.png": 9728,
	"./spades-queen.png": 5819,
	"./start_01.png": 8406,
	"./start_02.png": 9085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;